module.exports = __webpack_public_path__ + "static/img/row11.990e7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row11.png
// module id = yk5O
// module chunks = 12